import type { AnalysisBuffer } from '../types/image.js';
import type { QualityMetrics } from '../types/metrics.js';
import { computeBrightness } from './brightness.js';
import { computeCompression } from './compression.js';
import { computeNoise } from './noise.js';
import { computeSharpness } from './sharpness.js';

export { computeBrightness, patchMean } from './brightness.js';
export { computeCompression } from './compression.js';
export { computeNoise } from './noise.js';
export { computeRoiSharpness, computeSharpness } from './sharpness.js';
// Light/shadow/background-balance analysis added for the extended light-and-
// background checks. They consume the same analysis buffer as the quality stage.
export { analyzeHighlights } from './highlight.js';
export { analyzeFaceShadow, analyzeLightingBalance } from './lightingBalance.js';
export { analyzeBackgroundSurface } from './regions.js';

/**
 * The whole "deep" quality stage in one call.
 *
 * Deliberately independent of documents: the metrics describe the photo, the
 * document profile decides whether the numbers are acceptable.
 */
export const computeQualityMetrics = (buffer: AnalysisBuffer): QualityMetrics => {
  const noise = computeNoise(buffer);
  return {
    sharpness: computeSharpness(buffer),
    brightness: computeBrightness(buffer),
    noise,
    // The compression heuristic needs the noise floor to tell ringing from grain.
    compression: computeCompression(buffer, { noiseSigma: noise.sigma }),
    sampledAt: { width: buffer.width, height: buffer.height, scale: buffer.scale },
  };
};
